import React from 'react';

import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import Table from 'components/data-visualization/Table/Table';
import Body from 'components/data-visualization/Table/Body';

import { BrowseEntityItems } from 'components/data-containers/BrowseEntities/SkeletonLoader';

const SkeletonLoader: React.FC<{
  title: string;
  isWide: boolean;
}> = ({ title, isWide }) => {
  return (
    <GenericComponent
      title={title}
      loading={true}
      success={false}
      showToolbarDropdown={false}
      isWide={isWide}
    >
      <AnimatedLoadingWrapper loading={true}>
        <Table>
          <Body>
            <BrowseEntityItems />
          </Body>
        </Table>
      </AnimatedLoadingWrapper>
    </GenericComponent>
  );
};

export default SkeletonLoader;
